import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';

import { AuthGuard } from './components/auth-guard';
import { Layout } from './components/layout';
import { AgentsPage } from './pages/agents-page';
import { AiAuditListPage } from './pages/ai-audit/ai-audit-list-page';
import { Dashboard } from './pages/dashboard';
import { DocumentLegacyRedirect } from './pages/document/document-legacy-redirect';
import { DocumentsEmptyState } from './pages/document/documents-empty-state';
import { DocumentDFilesRoute } from './pages/document/files';
import { DocumentDHistoryRoute } from './pages/document/history';
import { DocumentDViewRoute } from './pages/document/view/route';
import { ProcessorDetailPage } from './pages/processor-detail-page';
import { ProcessorFilesPage } from './pages/processor-files-page';
import { ProcessorInstanceDetailPage } from './pages/processor-instance/processor-instance-detail-page';
import { ProcessorInstancesListPage } from './pages/processor-instance/processor-instances-list-page';
import { ProcessorsPage } from './pages/processors';
import { PromptsPage } from './pages/prompts';
import { SettingsPage } from './pages/settings';
import { UploadsListPage } from './pages/uploads/uploads-list-page';
import { UserSecretsPage } from './pages/user-secrets-page';
import { WorkspaceSettingsPage } from './pages/workspace-settings-page';

function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="documents/*" element={<DocumentLegacyRedirect />} />
            <Route path="d" element={<Outlet />}>
              <Route index element={<DocumentsEmptyState />} />
              <Route path="view/*" element={<DocumentDViewRoute />} />
              <Route path="history/*" element={<DocumentDHistoryRoute />} />
              <Route path="files/*" element={<DocumentDFilesRoute />} />
            </Route>
            <Route path="agents" element={<AgentsPage />} />
            <Route path="processors" element={<ProcessorsPage />} />
            <Route
              path="processors/:processorId/files"
              element={<ProcessorFilesPage />}
            />
            <Route
              path="processors/:processorId"
              element={<ProcessorDetailPage />}
            />
            <Route path="instance" element={<ProcessorInstancesListPage />} />
            <Route
              path="instance/:id"
              element={<ProcessorInstanceDetailPage />}
            />
            <Route path="prompts" element={<PromptsPage />} />
            <Route path="ai-audit" element={<AiAuditListPage />} />
            <Route path="uploads" element={<UploadsListPage />} />
            <Route path="secrets" element={<UserSecretsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route
              path="workspace/settings"
              element={<WorkspaceSettingsPage />}
            />
          </Route>
        </Routes>
      </AuthGuard>
    </BrowserRouter>
  );
}

export default App;
